import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';
import Skeleton from 'react-loading-skeleton';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Button from '../../components/Button/Button';
import StringInput from '../../components/Input/StringInput/StringInput';
import NumberInput from '../../components/Input/NumberInput/NumberInput';
import { formValidation, clearFormValidation } from '../../hoc/Shared/utility';
import ValidationError from '../../components/ValidationError/ValidationError';
import Select from "../../components/Input/Select/Select";
import Select2 from "../../components/Input/Select2/Select2";

import * as actions from '../../store/ducks/rescueBonusSetting/actions';

class RescueBonusSettingEdit extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state =
        {
            formFilter: {},
            gameVendor: [],
            vendor: [],
            gameType: [],
            loading: true,
            errMsg: [],
            touched: false,
        };
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() 
    {
        // console.log('componentDidMount (create):', this.state);
        formValidation('rescue_bonus_setting_form');
        if (this.props.selectId) 
        {
            this.props.funcGetDetails(this.props.selectId);
        }
    }

    shouldComponentUpdate(nextProps, nextState) 
    {
        const { t } = this.props;
        if (nextProps.details !== this.props.details && nextProps.details !== undefined) 
        {
            if (nextProps.details.responseCode === 200 && nextProps.details.msgType === 'success') 
            {
                let newInput = {};
                let gameVendor = [];
                let rescueBonusVendor = nextProps.details.data.rescue_bonus_vendor;
                let vendor = nextProps.details.data.game_vendor;
                let selectedVendor = [];

                vendor.map((item, idx) => 
                {
                    gameVendor.push({
                        'label': t(`vendor.${item.slug}`),
                        'value': item.id,
                    });
                    if (rescueBonusVendor.includes(item.id)) 
                    {
                        selectedVendor.push({
                            label: t(`vendor.${item.slug}`),
                            value: item.id,
                        });
                    }
                    return null;
                });

                for (const key in nextProps.details.data.result) 
                {
                    newInput[key] = nextProps.details.data.result[key];
                }

                let gameType = nextProps.details.data.game_type.map((val, idx) =>
                {
                    return {...val, category: t(`game-type.${val.slug}`)};
                });

                this.setState({
                    formFilter: newInput,
                    gameVendor,
                    gameType,
                    vendor: selectedVendor,
                    loading: false,
                });
            }
            // Swal.close();
        }

        if (nextProps.update !== this.props.update && nextProps.update !== undefined) 
        {
            let success = (nextProps.update.responseCode === 200 && nextProps.update.msgType === 'success') ? true : false;
            if (nextProps.update.responseCode === 200 && nextProps.update.msgType === 'success') 
            {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then(() => 
                {
                    clearFormValidation('rescue_bonus_setting_form');
                    this.props.refreshHandler();
                    this.props.changePageHandler('listing');
                });
            }
            else 
            {
                Swal.close();
            }

            this.setState({
                touched: (success) ? false : true,
                errMsg: (success) ? [] : nextProps.update.message
            });
        }

        return true;
    }

    onInputChange = (event) => 
    {
        // console.log(event.target.id+' | '+event.target.value);
        let newInput = Object.assign({}, this.state.formFilter);
        newInput[event.target.id] = event.target.value;
        this.setState({
            formFilter: newInput
        });
    }

    onVendorChange = (event) => 
    {
        this.setState({
            vendor: event,
        });
    }

    submitHandler = (e) => 
    {
        const { t } = this.props;
        e.preventDefault();
        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: 'warning',
            confirmButtonText: t("global.update"),
            showDenyButton: true,
            denyButtonText: t('global.cancel'),
        }).then((result) => 
        {
            if (result.isConfirmed) 
            {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => 
                    {
                        Swal.showLoading()
                    }
                });

                let data = this.state.formFilter;
                if(this.state.vendor)
                {
                    data.vendor = this.state.vendor.map((item) => item.value);
                }
                // console.log(data);
                this.props.funcUpdate(data);
            }
        });
    }

    render() 
    {
        const { t } = this.props;
        let permission = (this.props.currentUser.permission) ? this.props.currentUser.permission : [];
        
        return (
            <Auxiliary>
                <div className='breadcrumb-header'>
                    <div className='d-flex'>
                        <div className='my-auto'>
                            <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler('listing')} />
                        </div>
                    </div>
                    <div className='my-auto'>
                        <div className='d-flex'>
                            <h4 className='content-title mb-0 my-auto ml-2'>{t('side-bar.rescue_bonus_setting')}</h4>
                        </div>
                    </div>
                </div>
                <div className='row row-sm'>
                    <div className='col-12'>
                        <div className='card  box-shadow-0'>
                            <div className='card-header'>
                                <h4 className='card-title mb-1'>{t('role.rescue_bonus_setting_update')}</h4>
                            </div>

                            <div className='card-body pt-0'>
                                <form method='post' id='rescue_bonus_setting_form' className='form-horizontal' onSubmit={this.submitHandler} noValidate>
                                    <ValidationError formName='rescue_bonus_setting_form' touched={this.state.touched} message={this.state.errMsg} />
                                    {this.state.loading
                                        ?
                                        <Skeleton count={3} />
                                        :
                                        <>
                                            <div className='row'>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.slug')}</label>
                                                    <StringInput
                                                        id='slug'
                                                        name='slug'
                                                        className='form-control'
                                                        onChange={() => { }}
                                                        // placeholder={t('rescue-bonus-setting.slug')}
                                                        value={this.state.formFilter.slug || ''}
                                                        disabled
                                                    />
                                                </div>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.min-lose')}</label>
                                                    <NumberInput
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        id='min_lose'
                                                        name='min_lose'
                                                        min={1}
                                                        // max={45000}
                                                        placeholder={t('rescue-bonus-setting.min-bet')}
                                                        value={this.state.formFilter.min_lose || ''}
                                                        required
                                                    />
                                                </div>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.max-claim')}</label>
                                                    <NumberInput
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        id='max_claim'
                                                        name='max_claim'
                                                        min={1}
                                                        // max={45000}
                                                        placeholder={t('rescue-bonus-setting.max-claim')}
                                                        value={this.state.formFilter.max_claim || ''}
                                                        required
                                                    />
                                                </div>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.percent')}</label>
                                                    <NumberInput
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        id='percent'
                                                        name='percent'
                                                        // min={0.001}
                                                        // max={100}
                                                        placeholder={t('rescue-bonus-setting.percent')}
                                                        value={this.state.formFilter.percent || ''}
                                                        required
                                                    />
                                                </div>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.turnover')}</label>
                                                    <NumberInput
                                                        onKeyPress={(evt) => ((evt.key === 'e' || evt.key === '-' || evt.key === '+') && evt.preventDefault())}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        id='turnover'
                                                        name='turnover'
                                                        // min={0.001}
                                                        // max={100}
                                                        placeholder={t('rescue-bonus-setting.turnover')}
                                                        value={this.state.formFilter.turnover || ''}
                                                        required
                                                    />
                                                </div>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.game-type')}</label>
                                                    <Select  
                                                        id='game_type_id'  
                                                        name='game_type_id'
                                                        className='form-control'
                                                        getOptionValue='id'
                                                        getOptionLabel='category'
                                                        options={this.state.gameType}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.game_type_id}
                                                    />
                                                </div>
                                                <div className='col-md-8 col-12 form-group'>
                                                    <label>{t('rescue-bonus-setting.exclude-vendor')}</label>
                                                    <Select2
                                                        options={this.state.gameVendor}
                                                        name="data"
                                                        onChange={(event) => this.onVendorChange(event)}
                                                        value={this.state.vendor}
                                                        placeholder={t('global.select')}
                                                        // menuPlacement="bottom"
                                                    />
                                                </div>
                                                <div className='col-md-4 col-12 form-group'>
                                                    <label>{t('global.status')}</label>
                                                    <Select
                                                        id="status"
                                                        name="status"
                                                        className="form-control"
                                                        options={this.props.statusArr}
                                                        onChange={(event) => this.onInputChange(event)}
                                                        value={this.state.formFilter.status}
                                                    />
                                                </div>
                                                <div className='col-md-12 form-group mb-0 justify-content-end'>
                                                    <div>
                                                        {(permission.includes('rescue_bonus_setting_update')) &&
                                                            <Button typeButton='submit' classValue='btn btn-blue' idValue='save' buttonName={t('global.save')} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => 
{
    return {
        details: state.rescueBonusSetting.details,
        update: state.rescueBonusSetting.update,
        currentUser: state.currentUser.data,
    }
};

const mapDispatchToProps = dispatch => 
{
    return {
        funcGetDetails: (id) => dispatch(actions.getDetails(id)),
        funcUpdate: (data) => dispatch(actions.update(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(RescueBonusSettingEdit));